"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComparaisonHelper = void 0;
var ComparaisonHelper = /** @class */ (function () {
    function ComparaisonHelper() {
    }
    ComparaisonHelper.array = function (a1, a2) {
        /* Check types array, null, undefined */
        if (typeof a1 !== typeof a2) {
            return false;
        }
        /* If not arrays return true */
        if (!(a1 instanceof Array) && !(a2 instanceof Array)) {
            return true;
        }
        /* Basic check of the size to begin */
        if (a1.length !== a2.length) {
            return false;
        }
        /* Sort values */
        a1 = a1.sort();
        a2 = a2.sort();
        /* Look at every values */
        var i = 0;
        while (i < a1.length) {
            if (a1[i] !== a2[i]) {
                return false;
            }
            i++;
        }
        return true;
    };
    ComparaisonHelper.object = function (a1, a2) {
        /* Check types array, null, undefined */
        if (typeof a1 !== typeof a2) {
            return false;
        }
        /* If not objects return true */
        if (typeof a1 !== "object") {
            return false;
        }
        /* Basic check of the size to begin */
        var keys1 = Object.keys(a1);
        var keys2 = Object.keys(a2);
        if (keys1.length !== keys2.length) {
            return false;
        }
        /* Sort values */
        keys1 = keys1.sort();
        keys2 = keys2.sort();
        /* Look at every values */
        var i = 0;
        while (i < keys1.length) {
            if (a1[keys1[i]] !== a2[keys1[i]]) {
                return false;
            }
            i++;
        }
        return true;
    };
    return ComparaisonHelper;
}());
exports.ComparaisonHelper = ComparaisonHelper;
//# sourceMappingURL=ComparaisonHelper.js.map